import {ErrorHandler, NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import {HttpClientInMemoryWebApiModule} from 'angular-in-memory-web-api';
import {ClipboardModule} from 'ngx-clipboard';
import {TranslateModule} from '@ngx-translate/core';
import {InlineSVGModule} from 'ng-inline-svg';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {environment} from 'src/environments/environment';
import localeFr from '@angular/common/locales/fr';
import {registerLocaleData} from '@angular/common';
import {OktaAuthModule} from '@okta/okta-angular';
import {oktaAuth} from './core/_services/auth/auth.init';
// Highlight JS
import {HIGHLIGHT_OPTIONS, HighlightModule} from 'ngx-highlightjs';
import {SplashScreenModule} from './_metronic/partials/layout/splash-screen/splash-screen.module';
// #fake-start#
import {FakeAPIService} from './_fake/fake-api.service';
import {MAT_RADIO_DEFAULT_OPTIONS} from '@angular/material/radio';
import {MAT_CHECKBOX_DEFAULT_OPTIONS} from '@angular/material/checkbox';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {HttpRequestInterceptor} from './core/_util/http-request.interceptor';
import {ToastContainerModule, ToastrModule} from 'ngx-toastr';
import {TypeScriptCodeErrorInterceptor} from './core/_util/typescript-code-error.interceptor';
import {AuthInterceptor} from './core/_services/auth/auth-interceptor.service';



registerLocaleData(localeFr);

// #fake-end#


@NgModule({
    declarations: [AppComponent],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        SplashScreenModule,
        TranslateModule.forRoot(),
        HttpClientModule,
        HighlightModule,
        ClipboardModule,
        // #fake-start#
        environment.isMockEnabled
            ? HttpClientInMemoryWebApiModule.forRoot(FakeAPIService, {
                passThruUnknownUrl: true,
                dataEncapsulation: false,
            })
            : [],
        // #fake-end#
        AppRoutingModule,
        InlineSVGModule.forRoot(),
        NgbModule,
        MatProgressSpinnerModule,
        ToastrModule.forRoot(),
        ToastContainerModule,
        OktaAuthModule.forRoot({ oktaAuth })
    ],
    providers: [

        {
            provide: HIGHLIGHT_OPTIONS,
            useValue: {
                coreLibraryLoader: () => import('highlight.js/lib/core'),
                languages: {
                    xml: () => import('highlight.js/lib/languages/xml'),
                    typescript: () => import('highlight.js/lib/languages/typescript'),
                    scss: () => import('highlight.js/lib/languages/scss'),
                    json: () => import('highlight.js/lib/languages/json')
                },
            },
        },
        {
            provide: MAT_RADIO_DEFAULT_OPTIONS,
            useValue: {color: 'primary'},
        },
        {
            provide: MAT_CHECKBOX_DEFAULT_OPTIONS,
            useValue: {color: 'primary'},
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: HttpRequestInterceptor,
            multi: true
        },
        {
            provide: ErrorHandler,
            useClass: TypeScriptCodeErrorInterceptor
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptor,
            multi: true
        }

    ],
    bootstrap: [AppComponent],
})
export class AppModule {
}
